/* eslint-disable no-restricted-imports -- This file is the designated entry point for sentry imports */
import { wrapSentryForProject, mapEnvironmentToDSN } from '@grantstreet/sentry-multiplex'
import { isProd } from '@grantstreet/psc-environment'

const dsns = {
  // Send checkout widget alerts to GH. (Treating it like GH mini)
  // govhub-ui-prod & -nonprod projects
  prod: 'https://10c054b10b974c81b73423a0d835e640@o168195.ingest.sentry.io/1432778',
  nonprod: 'https://0b277d98b53c4c4ab0748b2ede995898@o168195.ingest.sentry.io/5827657',
}

// Also export the @grantstreet/sentry-multiplex way of doing things
const Sentry = wrapSentryForProject('cart-ui', {
  dsn: () => mapEnvironmentToDSN(dsns, isProd),
})
export default Sentry
export const sentryException = Sentry.captureException
